import { render, staticRenderFns } from "./vendorOrder.vue?vue&type=template&id=4921edc8&scoped=true&"
import script from "./vendorOrder.vue?vue&type=script&lang=js&"
export * from "./vendorOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4921edc8",
  null
  
)

export default component.exports